import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CreditCard, User, Map, BarChart } from 'lucide-react';

interface MobileNavLinkProps {
  to: string;
  icon: React.ReactNode;
  text: string;
}

const MobileNavLink = ({ to, icon, text }: MobileNavLinkProps) => {
  const location = useLocation();
  const isActive =
    (to === '/settings' && location.pathname === '/settings') ||
    (to === '/settings/account' && location.pathname.includes('/settings/account')) ||
    (to === '/settings/statistics' && location.pathname.includes('/settings/statistics')) ||
    (to === '/roadmap' && location.pathname.includes('/roadmap'));

  return (
    <Link
      to={to}
      className={`flex flex-col items-center justify-center space-y-0.5 py-1 ${
        isActive
          ? 'text-[#F37022]'
          : 'text-gray-600 dark:text-gray-300'
      }`}
    >
      {icon}
      <span className="text-[10px] leading-tight">{text}</span>
    </Link>
  );
};

export default function MobileBottomNav() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-50">
      <div className="grid grid-cols-4 gap-0.5 px-1 py-2">
        <MobileNavLink
          to="/settings/account"
          icon={<User className="h-5 w-5" />}
          text="Account"
        />
        <MobileNavLink
          to="/settings"
          icon={<CreditCard className="h-5 w-5" />}
          text="Billing"
        />
        <MobileNavLink
          to="/settings/statistics"
          icon={<BarChart className="h-5 w-5" />}
          text="Stats"
        />
        <MobileNavLink
          to="/roadmap"
          icon={<Map className="h-5 w-5" />}
          text="Roadmap"
        />
      </div>
    </div>
  );
} 